class e {
  constructor(t, ...s) {
    this.slotNames = [], this.host = t, this.host.addController(this), this.slotNames = s;
  }
  hasNamedSlot(t) {
    return this.host.querySelector(`:scope > [slot="${t}"]`) !== null;
  }
  test(t) {
    return this.hasNamedSlot(t);
  }
}
export {
  e as S
};
